import { useNavigate } from "react-router-dom";
import PageLayout from "./PageLayout ";

export default function JoinCouncil() {
  const navigate = useNavigate();
  return (
    <PageLayout
      title="Legal Advocacy"
      desc="Strengthening justice through lawful action, awareness, and constitutional empowerment."
    >
      <div className="advocacy-content">
        <p>
          Legal advocacy plays a crucial role in protecting rights, ensuring
          justice, and strengthening the rule of law in society. At ICSAJ
          (International Council of Sanatan Advocacy & Justice), our legal
          advocacy initiatives are focused on empowering individuals with
          knowledge, resources, and support to address legal challenges in a
          structured and lawful manner.
        </p>

        <p>
          In today’s rapidly evolving legal landscape, awareness is the first
          step towards empowerment. Many individuals remain unaware of their
          constitutional rights and legal remedies available to them. Legal
          advocacy bridges this gap by educating citizens, enabling them to
          understand the law, and guiding them in seeking justice through proper
          legal channels. It involves not only raising awareness but also
          actively engaging in lawful representation, policy dialogue, and
          institutional collaboration.
        </p>

        <p>
          Legal advocacy includes various approaches such as strategic
          litigation, policy reform efforts, legal awareness campaigns, and
          community-level engagement. These methods aim to address systemic
          issues, challenge injustice, and promote fairness in legal processes.
          It can involve working with legislators, supporting victims through
          legal aid, or participating in public interest matters that have a
          wider societal impact.
        </p>

        <h4 className="mt-4">Our Key Initiatives</h4>

        <ul className="advocacy-list">
          <li>Legal awareness programs and public education campaigns</li>
          <li>Support for constitutional and civil rights protection</li>
          <li>Public interest advocacy and legal representation</li>
          <li>Workshops, seminars, and training for young advocates</li>
          <li>Collaboration with legal professionals and institutions</li>
        </ul>

        <p>
          ICSAJ believes that advocacy is not limited to legal professionals
          alone. Every individual has a role to play in promoting justice and
          accountability. By understanding legal rights and responsibilities,
          citizens can contribute to building a more informed and equitable
          society. Our initiatives aim to encourage responsible participation
          while ensuring that all actions remain within the framework of law and
          constitutional values.
        </p>

        <p>
          We also emphasize ethical advocacy. The objective is not only to raise
          concerns but to do so responsibly, with respect for the law and social
          harmony. Our programs focus on constructive engagement, dialogue, and
          lawful solutions that strengthen democratic values and institutional
          trust.
        </p>

        <p>
          Through continuous research, awareness drives, and collaboration,
          ICSAJ aims to create a network of legally aware citizens and
          professionals who can contribute meaningfully to society. We strive to
          ensure that justice is accessible, rights are protected, and voices
          are heard through proper legal mechanisms.
        </p>

        <p>
          By joining our legal advocacy initiatives, you become part of a larger
          mission dedicated to justice, integrity, and social responsibility.
          Together, we can create a system where law serves as a tool for
          empowerment and positive change.
        </p>

        <div className="text-center mt-4">
          <button
            className="btn btn-danger px-4 py-2"
            onClick={() => navigate("/join-volunteer")}
          >
            Apply as Volunteer
          </button>
        </div>
      </div>
    </PageLayout>
  );
}
